var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex h-full gap-4"},[_c('SessionStopped',{attrs:{"start-session":_vm.startSession,"stop-session":_vm.stopSession},on:{"close-modal":function($event){return _vm.$emit('close-modal')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }